/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright (c) 2024 Marcel Suter - Replayer
 *
 * This source code is licensed under the AGPL license found in the
 * LICENSE file in the root of this projects source tree.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

/** A set of Replayer-specific svg icon paths */

export const rTrackPlay = 'm 7,17 h 10 v -3 l 4,4 -4,4 V 19 H 5 v -6 h 2';

export const rTrackRepeat =
    'M 17,17 H 7 v -3 l -4,4 4,4 V 19 H 19 V 13 H 17 M 7,7 h 10 v 3 L 21,6 17,2 V 5 H 5 v 6 h 2 z';

export const rTrackPlayOnce =
    'm 7,17 h 10 v -3 l 4,4 -4,4 V 19 H 5 v -6 h 2 m 7,2 V 9 h -1 l -2,1 v 1 h 1.5 v 4';

export const rTrackRepeatOnce =
    'M13,15V9H12L10,10V11H11.5V15M17,17H7V14L3,18L7,22V19H19V13H17M7,7H17V10L21,6L17,2V5H5V11H7V7Z';

export const rRepeatVariant =
    'M6,5.75L10.25,10H7V16H13.5L15.5,18H7A2,2 0 0,1 5,16V10H1.75L6,5.75M18,18.25L13.75,14H17V8H10.5L8.5,6H17A2,2 0 0,1 19,8V14H22.25L18,18.25Z';

export const rShuffleVariant =
    'M17,3L22.25,7.5L17,12L22.25,16.5L17,21V18H14.26L11.44,15.18L13.56,13.06L15.5,15H17V12L17,9H15.5L6.5,18H2V15H5.26L14.26,6H17V3M2,6H6.5L9.32,8.82L7.2,10.94L5.26,9H2V6Z';

export const rFadeInFadeOutOff =
    'M 11 2 L 8.6132812 6.7714844 L 11 8.9238281 L 11 2 z M 13 2 L 13 10.728516 L 20.949219 17.896484 L 13 2 z M 6.4160156 7.0976562 L 5.2675781 8.3710938 L 7.0234375 9.9550781 L 2 20 L 11 20 L 11 13.541016 L 13 15.345703 L 13 20 L 18.162109 20 L 20.119141 21.765625 L 21.267578 20.494141 L 15.984375 15.728516 L 13 13.037109 L 11 11.234375 L 7.8183594 8.3632812 L 6.4160156 7.0976562 z';

export const rFadeInFadeOutOn = 'M 11,20 H 2 L 11,2 m 2,18 h 9 L 13,2';

/** An icon denoting a preplay action */
export const rPlayPreplay =
    'm 1.9804688,5 c 0,4.6666667 0,9.333333 0,14 0.5442708,0 1.0885416,0 1.6328124,0 0,-2 0,-4 0,-6 2.4622396,0 4.9244792,0 7.3867188,0 0,2 0,4 0,6 3.666667,-2.333333 7.333333,-4.666667 11,-7 -3.666667,-2.3333333 -7.333333,-4.6666667 -11,-7 0,2 0,4 0,6 -2.4622396,0 -4.9244792,0 -7.3867188,0 0,-2 0,-4 0,-6 C 3.0690104,5 2.5247396,5 1.9804688,5 Z';

/** An icon denoting an immediate play action */
export const rPlayDirect =
    'm 11,5 c 0,4.6666667 0,9.333333 0,14 3.666667,-2.333333 7.333333,-4.666667 11,-7 C 18.333333,9.6666667 14.666667,7.3333333 11,5 Z';

/** An icon denoting a fade-in, pre-roll and play action */
export const rFadeInPreRollPlay =
    'M 5,8.25 C 4.2015381,8.3348205 4.198304,9.2054507 3.9491603,9.7826531 3.452435,11.271769 2.9557097,12.760884 2.4589844,14.25 2.0782185,14.168708 1.9052628,14.295225 2,14.689436 2,15.042957 2,15.396479 2,15.75 2.6270953,15.709444 3.4987029,15.95868 3.7418377,15.143693 4.3415637,13.345796 4.9412896,11.547898 5.5410156,9.75 c 2.6308595,0 5.2617194,0 7.8925784,0 0,-0.5 0,-1 0,-1.5 -2.811198,0 -5.622396,0 -8.433594,0 z M 11,5 c 0,4.6666667 0,9.333333 0,14 3.666667,-2.333333 7.333333,-4.666667 11,-7 C 18.333333,9.6666667 14.666667,7.3333333 11,5 Z';

/** An icon denoting a play and subsequent fade-in action */
export const rPlayFadeIn =
    'M 20,8.25 C 19.208686,8.3306079 19.201667,9.1876259 18.957139,9.7587332 18.457754,11.255822 17.958369,12.752911 17.458984,14.25 17.140744,14.206374 16.885103,14.225346 17,14.614856 c 0,0.378381 0,0.756763 0,1.135144 0.614765,-0.04546 1.446334,0.208849 1.725368,-0.556936 C 19.330584,13.37871 19.9358,11.564355 20.541016,9.75 20.859256,9.7936261 21.114897,9.7746541 21,9.3851438 21,9.0067626 21,8.6283813 21,8.25 c -0.333333,0 -0.666667,0 -1,0 z M 3,5 C 3,9.6666667 3,14.333333 3,19 6.6666667,16.666667 10.333333,14.333333 14,12 10.333333,9.6666667 6.6666667,7.3333333 3,5 Z';

/** An icon denoting a fade-in and play action */
export const rFadeInPlay =
    'M 6,8.25 C 5.2086862,8.3306084 5.2016679,9.187626 4.9571392,9.7587332 4.4577543,11.255822 3.9583693,12.752911 3.4589844,14.25 3.1407449,14.206374 2.8851031,14.225346 3,14.614856 3,14.993237 3,15.371619 3,15.75 3.614765,15.704539 4.4463341,15.958849 4.7253689,15.193064 5.3305845,13.37871 5.9358,11.564355 6.5410156,9.75 6.8592551,9.793626 7.1148969,9.7746543 7,9.3851438 7,9.0067626 7,8.6283813 7,8.25 c -0.3333333,0 -0.6666667,0 -1,0 z M 10,5 c 0,4.6666667 0,9.333333 0,14 3.666667,-2.333333 7.333333,-4.666667 11,-7 C 17.333333,9.6666667 13.666667,7.3333333 10,5 Z';

/** An icon denoting a pre-roll and subsequent play action (without fade-in) */
export const rPreRollPlay =
    'M 4,8.25 C 3.1913793,8.2660654 3.2298569,9.1138522 3.25,9.6841053 3.25,11.20607 3.25,12.728035 3.25,14.25 2.8471288,14.128093 3.0453095,14.607237 3,14.842891 3,15.145261 3,15.44763 3,15.75 3.5668891,15.702276 4.2616201,15.928052 4.6494965,15.374984 4.8400141,14.723382 4.7135804,14.030042 4.75,13.358147 c 0,-1.202715 0,-2.405431 0,-3.608147 2.0833333,0 4.1666667,0 6.25,0 0,-0.5 0,-1 0,-1.5 -2.3333333,0 -4.6666667,0 -7,0 z M 10,5 c 0,4.6666667 0,9.333333 0,14 3.666667,-2.333333 7.333333,-4.666667 11,-7 C 17.333333,9.6666667 13.666667,7.3333333 10,5 Z';

/** An close icon with a small cross */
export const rCloseCircleSmall =
    'M 14.59,8 12,10.59 9.41,8 8,9.41 10.59,12 8,14.59 9.41,16 12,13.41 14.59,16 16,14.59 13.41,12 16,9.41 Z';

/** An empty icon (as placeholder) */
export const rNone = 'M Z';
